import { BUSINESS_ADMIN_HOST } from 'api/constants';

export const GET_ALL_ROLES_URL = `${BUSINESS_ADMIN_HOST}/v1/internal-roles`;
export const CREATE_NEW_INTERNAL_USER_URL = `${BUSINESS_ADMIN_HOST}/v1/internal-users`;
export const GET_ALL_INTERNAL_USERS = `${BUSINESS_ADMIN_HOST}/v1/internal-users`;
export const GET_ACCESS_LOGS = `${BUSINESS_ADMIN_HOST}/v1/logs`;
export const UPDATE_INTERNAL_USER = `${BUSINESS_ADMIN_HOST}/v1/internal-users`;
export const DELETE_INTERNAL_USER = `${BUSINESS_ADMIN_HOST}/v1/internal-users`;
export const RESET_INTERNAL_USER_PASSWORD = `${BUSINESS_ADMIN_HOST}/v1/internal-users`;
